import React, { PureComponent } from "react";
import _ from "lodash";
import { COURSES_TAB, SEARCH_QUERY_LENGTH } from '../course-Management/Constants/constants';
export interface ChildProps {
  data: any;
  loading: boolean;
  onPageChange: (pageNo: number) => void;
  onSearchQueryChange: (searchQuery: string) => void;
  handleSearchClose: (searchQuery: string) => void;
  searchQuery: string;
  currentPageNo: number;
  filters: Filter;
  handleFilterChange: Function;
  totalCount: number;
}
interface Props {
  loading?: boolean;
  children: (props: ChildProps) => any;
  fetchAllData: Function;
  filters: Filter;
  data?: any;
  pageSize?: number;
  resetFilter?: any;
  updateFilter?: any;
  totalCount?: number;
}
interface Filter {
  [key: string]: {
    isMultiple?: boolean;
    values?: any;
  };
}
interface State {
  data: any[];
  currentPageNo: number;
  loading: boolean;
  searchQuery: string;
  pagination: boolean;
  pageSize: number;
  totalPages: number;
  filters: Filter;
  courseState: any;
  requestState: any;
  totalCount: number
}

class MyPATLandingContainer extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      loading: false,
      data: props.data || [],
      currentPageNo: 1,
      searchQuery: "",
      pageSize: props.pageSize || 10,
      pagination: true,
      totalPages: 0,
      filters: props.filters,
      courseState: {},
      requestState: {},
      totalCount: (this.props.totalCount || 0)
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleChange = _.debounce(this.handleChange, 200);
    if (this.props.updateFilter) {
      this.props.updateFilter.current = this.handleFilterChange;
    }
  }

  handlePageChange = (currentPageNo: number) => {
    this.setState({ currentPageNo });
  };

  handleSearchQuery = (searchQuery: string) => {
    this.setState({ searchQuery, currentPageNo: 1 });
  };

  handleSearchClose = (e: any) => {
    const { value } = e.target;
    const { searchQuery } = this.state;
    if (searchQuery) {
      this.setState({ searchQuery: '', currentPageNo: 1 });
    } else {
      this.setState({ searchQuery: value });
    }
  };

  resetFilter = (filterType: string) => {
    const cloneState = JSON.parse(JSON.stringify(this.state));
    cloneState.requestState = {};
    cloneState.courseState = {};

    if (COURSES_TAB.COURSES === filterType) {
      this.setState({
        ...this.state.courseState,
        requestState: cloneState
      });
    } else {
      this.setState({
        ...this.state.requestState,
        courseState: cloneState
      });
    }
  }

  handleFilterChange = (key: string, value: any, isFinalValue?: boolean) => {
    this.setState(
      (prevState) => {
        const { filters } = prevState;
        const newFilter = { ...filters };
        let filter = { ..._.get(newFilter, `${key}`) };
        if (!filter) {
          return prevState;
        }
        if (!isFinalValue) {
          if (filter.isMultiple) {
            let values = [...filter.values];
            if (values.includes(value)) {
              const index = values.indexOf(value);
              values.splice(index, 1);
            } else {
              values.push(value);
            }
            filter.values = values;
          } else {
            filter.values = value;
          }
        } else {
          filter.values = value;
        }
        newFilter[key] = filter;
        return { ...prevState, filters: { ...newFilter }, currentPageNo: 1 };
      },
      () => this.handleChange()
    );
  };
  handleChange = async () => {
    const { currentPageNo, searchQuery, pageSize, pagination } = this.state;
    const { fetchAllData } = this.props;
    let { filters } = this.state;
    const reqParams = {
      pagination,
      currentPageNo,
      pageSize,
      searchQuery,
      filters,
    };
    const res = await fetchAllData(reqParams);
    this.setState({ data: res, loading: true, totalCount: res.totalCount });
  };
  componentDidMount() {
    this.handleChange();
    if (this.props.resetFilter) {
      this.props.resetFilter.current = this.resetFilter;
      this.resetFilter(COURSES_TAB.COURSE_CHANGE_REQUEST);
      this.resetFilter(COURSES_TAB.COURSES);
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (
      prevState.currentPageNo !== this.state.currentPageNo ||
      prevState.searchQuery !== this.state.searchQuery
    ) {
      if (this.state.searchQuery.length >= SEARCH_QUERY_LENGTH && this.state.searchQuery.trim()) {
        this.handleChange();
      } else if(!this.state.searchQuery.length) {
        // this.setState({searchQuery: '', currentPageNo: 1})
        this.handleChange();
      }
    }
    if(prevProps.filters !== this.props.filters) {
      this.setState({ filters: this.props.filters })
    }
  }
  render() {
    const { data, loading, searchQuery, currentPageNo, filters, totalCount } = this.state;
    return this.props.children({
      loading,
      data,
      onPageChange: this.handlePageChange,
      onSearchQueryChange: this.handleSearchQuery,
      handleSearchClose: this.handleSearchClose,
      searchQuery,
      currentPageNo,
      filters,
      handleFilterChange: this.handleFilterChange,
      totalCount
    });
  }
}

export default MyPATLandingContainer;
